import React from 'react';
import styled from 'styled-components';
import HeaderEs from '../common/header/HeaderEs';
import { split } from 'lodash';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { reqEsOrderCodeReset, reqEsOrderInfoAction } from '../../modules/od/orderModule';
import { useSelector, useDispatch } from 'react-redux';
import { useState } from 'react';
import EsOrderDonePayinfo from './EsOrderDonePayinfo';
import EsOrderDoneDvryInfo from './EsOrderDoneDvryInfo';
import EsOrderDoneProdInfo from './EsOrderDoneProdInfo';
import {showAmount, FormatNumber} from '../../lib/util/CommonFunctions';

import {isMobileOnly} from 'react-device-detect';
import { EsComItemList, EsComSummary, EsReqDvryInfo, EsReqMustGuide, EsReqRefund } from './index';
import esItemsReducer from '../../modules/es/esItemModule';

// Modal Stryle
export const EsOrderDonePopupModalStyles = {
    content: {
        /* top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '10%',
        transform: 'translate(-50%, -50%)', */
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        marginRight: 'auto',
        postion: 'fixed',


        zIndex: '999',
        overlay: 'auto',
        WebkitOverflowScrolling: 'touch',
        width: "100%",
        height: "100%",
        borderRadius: '0px',
        backgroundColor: '#fff',
        borderWidth: '0px',
        padding: 0
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: '1000'
    }
};

const EsOrderDoneInfoPopupBlock = styled.div`
  ${isMobileOnly&&`margin: 0 4vw;`};
  .mobile-header {margin:40px; text-align: center;}
`;

const EsOrderDoneWrapBlock = styled.div`
    padding: 120px 0 100px;  
    width: 100%;
    max-width: 1176px;
    margin: 0 auto;
`;
const EsOrderDoneMobileWrapBlock = styled.div` 
    padding-bottom: 170px;
    // .splitter {border-bottom: 2px solid #ececec; padding-bottom:10px;}
    .product-table {
      margin: 10px 0;
      border-top: 2px solid #111;  
    }    
`;

const EsOrderDonePopup = ({ esItem, od_id, onCloseClick }) => {

    const history = useHistory();
    const dispatch = useDispatch();

    const { esOrderInfo, error } = useSelector(
        ({ userReducer, esOrderReducer, headerReducer }) => ({
            esOrderInfo: esOrderReducer.esOrderInfo,
            esItemInfo: esItemsReducer.esItemInfo,
            error: esOrderReducer.error
        })
    );

    useEffect(() => {
        if (error !== null) {
            dispatch(reqEsOrderCodeReset());
            onCloseClick();
        } else if ((esOrderInfo !== null && esOrderInfo.code === 600)) {
            dispatch(reqEsOrderCodeReset());
            onCloseClick();
        }
    }, [error, esOrderInfo])


    useEffect(() => {
        dispatch(reqEsOrderInfoAction("?odid=" + od_id));
    }, [od_id])


    if (esOrderInfo === null || esOrderInfo === undefined) {
        return <EsOrderDoneInfoPopupBlock />
    }

    const isVbank = () => {
        return (esOrderInfo.data.orderinfo.od_pay_type_code === '150402');
    }
    const getId = () => {
        if(esOrderInfo.data.orderinfo.es_rqst_id !== undefined && esOrderInfo.data.orderinfo.es_rqst_id !== null)
        {
            return esOrderInfo.data.orderinfo.es_rqst_id;
        }

        return esOrderInfo.data.orderinfo.es_id;
    }

    return (<EsOrderDoneInfoPopupBlock>
          {isMobileOnly?
            <div className="flex vc fe">
                <div className="mobile-header title-xl font-bold margin_b-40 margin_t-40 flex-1 text_center">주문완료</div>
                < i className="fas fa-times fa-2x" onClick={onCloseClick}/>
            </div>
            :
            <HeaderEs rqst_id={null} isLogoShow={false} name="주문완료" onCloseClick={onCloseClick} />
          }

          {isMobileOnly?
            <EsOrderDoneMobileWrapBlock>
                <div className="title-lg margin_b-30">
                    {esOrderInfo.data.orderinfo.pckg_nm}
                </div>
                <div className="flex vc jsb">
                    <div>{esOrderInfo.data.orderinfo.od_id}</div>
                    <div>주문일자: {esOrderInfo.data.orderinfo.od_reg_date}</div>
                </div>
                <p className="margin_t-20" style={{ display: isVbank() ? 'block' : 'none' }}>
                    선택하신 은행으로 입금해주시길 바랍니다.
                </p>

                <div className="margin_b-40">
                    {/*<div className="product-table default-table">*/}
                        {/*<EsComItemList items={esItem} />*/}
                    {/*</div>*/}
                </div>
                <EsOrderDonePayinfo esOrderInfo={esOrderInfo} />
                <EsOrderDoneDvryInfo esOrderInfo={esOrderInfo} />
                {/*<EsOrderDoneProdInfo esOrderInfo={esOrderInfo} isShowGuide={false} />*/}
                <div className="margin_b-80">
                    <div className="flex jsb vc">
                            {/* #2824 es_id->es_rqst_id 로 변경 */}
                        <div>{esOrderInfo.data.orderinfo.brnd_han}</div>
                        <div className="d-inline margin_l-20 font-mont">NO. {getId()}</div>
                    </div>
                    <EsComItemList items={esItem}/>
                </div>


            </EsOrderDoneMobileWrapBlock>
            :
            <EsOrderDoneWrapBlock>
                <div style={{ marginTop: '60px', marginBottom: '80px' }}>
                    <div className="sz-wrap">

                        <div className="es_title-box margin_b-60">
                            <h3 className="es_title margin_b-14">
                                {esOrderInfo.data.orderinfo.pckg_nm}
                            </h3>
                            <p className="es_date gray margin_b-40">
                                <span>주문 일자 : <span>{esOrderInfo.data.orderinfo.od_reg_date}</span></span>
                                <span className="d-inline margin_l-15">주문 번호 : <span>{esOrderInfo.data.orderinfo.od_id}</span></span>
                            </p>
                            <div className="save_pay-box clearfix margin_b-15" style={{ backgroundColor: '#1bd3aa' }}>
                                <span className="f-left">결제 금액</span>
                                <span className="save_pay f-right"><span className="font-mont">
                                {Number(esOrderInfo.data.orderinfo.od_pay_price.toFixed(1)).toLocaleString()}</span>원</span>
                            </div>
                            <p style={{ display: isVbank() ? 'block' : 'none' }}>
                                선택하신 은행으로 입금해주시길 바랍니다.
                            </p>
                        </div>

                        <EsOrderDonePayinfo esOrderInfo={esOrderInfo} />
                        <EsOrderDoneDvryInfo esOrderInfo={esOrderInfo} />
                        {/*<EsOrderDoneProdInfo esOrderInfo={esOrderInfo} isShowGuide={false} />*/}
                        <div className="filter-top myes_top clearfix">
                            <span className="f-left"><b style={{ fontSize: '18px' }}>주문 상품 정보</b></span>
                            <div className="filter-fc f-right clearfix">
                                <p>
                                    {/* #2824 es_id->es_rqst_id 로 변경 */}
                                    {esOrderInfo.data.orderinfo.brnd_han} <span className="d-inline margin_l-20 font-mont">NO. {getId()}</span>
                                </p>
                            </div>
                        </div>
                        <div className="product-table default-table">
                            <table>
                                <colgroup>
                                    <col width="550px;" />
                                    <col width="156px;" />
                                    <col width="156px;" />
                                    <col width="156px;" />
                                    <col width="156px;" />
                                </colgroup>

                                <thead>
                                <tr>
                                    <th>상품 정보</th>
                                    <th>상품 금액</th>
                                    <th>할인 금액</th>
                                    <th>배송비</th>
                                    <th>견적 금액</th>
                                </tr>
                                </thead>

                                <tbody>
                                <EsComItemList items={esItem}/>
                                </tbody>
                                <EsComSummary item={esItem[0]} type="tableTr"/>
                            </table>
                        </div>


                    </div>
                </div>

            </EsOrderDoneWrapBlock >
          }

          <div className="es_apply_info-box margin_b-100">
              <p>
                  결제, 배송 정보는 이메일로 확인 가능하며,
              </p>
              <p>주문 관련 문의는 고객센터로 연락 바랍니다.</p>

              <p className="margin_t-30">
                  주문일 :
                  <span className="font-mont">
                        {esOrderInfo.data.orderinfo.od_reg_date}
                    </span>
              </p>
          </div>
    </EsOrderDoneInfoPopupBlock >
    );
};

export default EsOrderDonePopup;
